import { defineComponent as N, computed as a, openBlock as o, createElementBlock as i, createElementVNode as u, normalizeClass as n, renderSlot as s, createTextVNode as c, toDisplayString as b, createCommentVNode as r, createBlock as O, resolveDynamicComponent as V, unref as f, mergeProps as I, withCtx as F, createVNode as $ } from "vue";
import { RevButtonBase as q } from "@ds/components/ButtonBase";
import z from "../../../icons/generated/IconChevronDown.vue2.js";
import { tw as t } from "../../../utils/tailwind.js";
import { VariantsEnum as m } from "../InputSelect.constant.js";
const D = ["for"], A = ["for"], H = /* @__PURE__ */ N({
  name: "InputSelectButton",
  inheritAttrs: !1,
  __name: "InputSelectButton",
  props: {
    hasError: { type: Boolean },
    disabled: { type: Boolean },
    focused: { type: Boolean },
    hasSelectedOption: { type: Boolean },
    required: { type: Boolean },
    selectId: {},
    useButtonBase: { type: Boolean, default: !1 },
    variant: { default: () => m.Floating }
  },
  emits: ["click-label"],
  setup(e, { emit: h }) {
    const v = h, w = () => {
      v("click-label");
    }, l = a(() => e.variant === m.Fixed), x = a(() => [
      t`pointer-events-none absolute inset-x-12 top-0 flex items-center pr-16`,
      !e.disabled && e.hasSelectedOption && t`text-static-default-low top-4 h-auto`,
      !e.disabled && !e.hasSelectedOption && t`text-action-default-hi`,
      e.disabled && t`text-static-default-low-disabled`,
      e.hasSelectedOption ? t`caption` : t`body-1 h-full`
    ]), B = a(() => [
      t`label-large mb-8 block`,
      t`pointer-events-none`,
      t`text-action-default-hi`,
      t`max-w-full truncate`,
      e.disabled && t`text-action-default-hi-disabled`
    ]), y = a(() => [
      t`rounded-sm body-1 absolute inset-x-0 size-full grow`,
      l.value ? t`bottom-0` : t`bottom-2`,
      t`appearance-none truncate border-0 bg-transparent text-start outline-none`
    ]), g = a(() => [
      t`pointer-events-none absolute right-12 shrink-0 select-none`,
      e.disabled && t`text-static-default-low-disabled`,
      !e.disabled && e.hasSelectedOption && t`text-static-default-low`,
      !e.disabled && !e.hasSelectedOption && t`text-action-default-hi`
    ]), C = a(() => l.value ? e.focused ? e.hasError ? t`border-action-danger-low outline-style-default-hi outline-1 outline-[#F8545B]` : t`border-action-default-low-pressed outline-style-default-hi outline-1 outline-current` : !e.disabled && e.hasError ? t`border-action-danger-hi` : t`border-action-default-low` : null), k = a(() => [
      t`pointer-events-none absolute inset-0 rounded-sm border border-solid`,
      t`ease-in-out motion-safe:transition-colors motion-safe:duration-200`,
      e.disabled && t`border-action-default-low-disabled`,
      !e.disabled && !e.focused && !e.hasError && t`border-action-default-low`,
      !e.disabled && !e.focused && e.hasError && t`border-action-danger-low`,
      !e.disabled && e.focused && !e.hasError && t`border-retina border-action-default-low-pressed`,
      !e.disabled && e.focused && e.hasError && t`border-retina border-action-danger-low-pressed`
    ]), S = a(() => e.disabled ? t`bg-static-default-low-disabled border-action-default-low-disabled text-action-default-hi-disabled` : t`bg-static-default-low text-action-default-hi hover:bg-static-default-low-hover`), E = a(() => [
      // Base styles
      t`rounded-sm relative flex w-full items-center px-12`,
      l.value && t`border`,
      !l.value && t`outline-none`,
      l.value ? t`h-40` : t`h-48`,
      t`ease-in-out motion-safe:transition-colors motion-safe:duration-200`,
      // State and variant specific styles
      S.value,
      C.value
    ]);
    return (d, L) => (o(), i("div", null, [
      l.value ? (o(), i("div", {
        key: 0,
        onClick: w
      }, [
        u("label", {
          class: n(B.value),
          for: e.selectId
        }, [
          s(d.$slots, "label"),
          c(b(e.required ? " *" : ""), 1)
        ], 10, D)
      ])) : r("", !0),
      (o(), O(V(e.useButtonBase ? f(q) : "span"), I({
        "aria-disabled": e.disabled,
        class: E.value,
        disabled: e.disabled
      }, d.$attrs), {
        default: F(() => [
          l.value ? r("", !0) : (o(), i("div", {
            key: 0,
            "aria-hidden": "true",
            class: n(k.value)
          }, null, 2)),
          l.value ? r("", !0) : (o(), i("label", {
            key: 1,
            class: n(x.value),
            for: e.selectId
          }, [
            s(d.$slots, "label"),
            c(b(e.required ? " *" : ""), 1)
          ], 10, A)),
          u("span", {
            class: n(y.value)
          }, [
            s(d.$slots, "value")
          ], 2),
          $(f(z), {
            class: n(g.value),
            size: "20"
          }, null, 8, ["class"])
        ]),
        _: 3
      }, 16, ["aria-disabled", "class", "disabled"]))
    ]));
  }
});
export {
  H as default
};
